// extracted by mini-css-extract-plugin
module.exports = {"container":"DivisionTabs_container_lpA3C","divisionNumber":"DivisionTabs_divisionNumber_h02bJ","smallText":"DivisionTabs_smallText_epTvY"};